import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=0edf9cc0&scoped=true"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"
import style0 from "./Expired.vue?vue&type=style&index=0&id=0edf9cc0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf9cc0",
  null
  
)

export default component.exports